/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import { Text as TextPrimitive, TouchableOpacity } from '@staffino/primitives';
import {
  color,
  ColorProps,
  space,
  SpaceProps,
  style,
  typography,
  TypographyProps,
} from 'styled-system';
import { StyledComponent } from '@emotion/styled';
import React from 'react';
import styled from './styled';

const textDecoration = style({
  prop: 'textDecoration',
});

const textTransform = style({
  prop: 'textTransform',
});

type LinkProps = React.ComponentProps<typeof TextPrimitive> &
  ColorProps &
  TypographyProps &
  SpaceProps;

const Link: StyledComponent<LinkProps> = styled(TouchableOpacity)(
  color,
  typography,
  space,
  textDecoration,
  textTransform,
);

Link.defaultProps = {
  lineHeight: 1.2,
  color: 'text',
};

export default Link.withComponent('a');
